import React, { Component } from "react";
import Axios from "axios";
import { Modal, Button, Form } from "react-bootstrap";
import { getAccessToken } from "../../hooks/AccessToken";
import Constant from "../Constant";

class HomepageBannerManagement extends Component {
  state = {
    banners: [],
    showModal: false,
    name: "",
    image: "",
    type: "contest",
    eventId: "",
    message: "",
    rank: 0,
    eventOptions: [],
    isEditing: false, // New state to track editing
    editBannerId: null, // New state to store the ID of the banner being edited
  };

  defaultImageUrl =
    "https://t3.ftcdn.net/jpg/01/15/40/12/360_F_115401245_GYPbMWpOT59rUcfObToRcFjyF2KFYIAe.jpg";

  componentDidMount() {
    this.fetchBanners();
  }

  fetchBanners = async () => {
    try {
      const token = getAccessToken();
      const response = await Axios.get(
        `${Constant.apiBasePath}HomepageBanner/get-all`,
        {
          headers: { token },
        }
      );
      this.setState({ banners: response.data.data });
    } catch (err) {
      console.error("Error fetching banners:", err);
    }
  };

  handleChange = async (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });

    if (name === "type") {
      await this.fetchEventOptions(value);
    }
  };

  fetchEventOptions = async (type) => {
    try {
      const token = getAccessToken();
      let response;

      if (type === "contest") {
        response = await Axios.post(
          `${Constant.apiBasePath}contest/get-all`,
          {},
          { headers: { token } }
        );
      } else if (type === "open-mic") {
        response = await Axios.get(`${Constant.apiBasePath}open-mic/get-all`, {
          headers: { token },
        });
      } else if (type === "openMic") {
        response = await Axios.post(
          `${Constant.apiBasePath}openMic/get-all`,
          {},
          { headers: { token } }
        );
      } else if (type === "registration") {
        response = await Axios.get(
          `${Constant.apiBasePath}registration-forms/get-all`,
          { headers: { token } }
        );
      } else if (type === "meetings") {
        response = await Axios.get(`${Constant.apiBasePath}meeting/get-all`, {
          headers: { token },
        });
      } else if (type === "simple-banner") {
        response = await Axios.get(
          `${Constant.apiBasePath}simple-banner/getAll`,
          { headers: { token } }
        );
      }

      //  "_id": "6788fab3c3a09024e094bf39",
      //       "sdkKey": "bvpubYM0QrE8RVGwfAm1Q",
      //       "sdkSecret": "Bwqqhn3dqysYH68HHsMGhPKfV9tu3AKD",
      //       "meetingNumber": "83649863786",
      //       "passWord": "257773",
      //       "role": 0,
      //       "status": true,
      //       "startTime": "2025-02-06T12:54:00.000Z",
      //       "endTime": "2025-02-20T12:53:00.000Z",
      //       "name": "Anti-Matterr",
      //       "description": "Anti-matter event ",
      //       "thumbnail": "https://story-tent-testing.s3.ap-south-1.amazonaws.com/story/story_1737030301019.jpg",
      //       "createdAt": "2025-01-16T12:25:23.988Z",
      //       "updatedAt": "2025-02-18T09:34:00.672Z",
      //       "__v": 0

      if (response?.data?.meetings) {
        const mappedOptions = response.data.meetings.map((event) => ({
          _id: event._id,
          name: event.name,
          description: event.description,
          thumbnail: event.thumbnail,
          image: event.thumbnail,
          mobileImage: event.mobileImage || null,
          sdkKey: event.sdkKey,
          sdkSecret: event.sdkSecret,
          meetingNumber: event.meetingNumber,
          passWord: event.passWord,
          status: event.status,
          startTime: event.startTime,
          endTime: event.endTime,
        }));
        this.setState({ eventOptions: mappedOptions });
      } else if (response?.data?.data) {
        const mappedOptions = response.data.data.map((event) => ({
          _id: event._id,
          name: event.name,
          image:
            type === "registration"
              ? event.thumbnail
              : event.image || this.defaultImageUrl,
          mobileImage: event.mobileImage || null,
        }));
        this.setState({ eventOptions: mappedOptions });
      }
    } catch (err) {
      console.error(`Error fetching ${type} options:`, err);
    }
  };

  handleShowModal = () => {
    this.setState({ showModal: true });
  };

  handleModalClose = () => {
    this.setState({
      showModal: false,
      name: "",
      image: "",
      type: "contest",
      eventId: "",
      rank: 0,
      eventOptions: [],
      isEditing: false,
      editBannerId: null,
    });
  };

  handleAddBanner = async () => {
    const { name, image, type, eventId, rank, isEditing, editBannerId } =
      this.state;

    try {
      const token = getAccessToken();
      const selectedEvent = this.state.eventOptions.find(
        (event) => event._id === eventId
      );

      const bannerName = selectedEvent.name;
      const bannerImage =
        selectedEvent.image && selectedEvent.image !== ""
          ? selectedEvent.image
          : type === "openMic" || type === "open-mic"
          ? this.defaultImageUrl
          : "";
      const bannerMobileImage = selectedEvent.mobileImage || null;

      const bannerData = {
        name: bannerName,
        image: bannerImage,
        mobileImage: bannerMobileImage,
        type,
        eventId,
        rank,
      };
      // Add meeting details if type is meetings
      if (type === "meetings" && selectedEvent) {
        bannerData.meetingDetails = {
          description: selectedEvent.description,
          sdkKey: selectedEvent.sdkKey,
          sdkSecret: selectedEvent.sdkSecret,
          meetingNumber: selectedEvent.meetingNumber,
          passWord: selectedEvent.passWord,
          status: selectedEvent.status,
          startTime: selectedEvent.startTime,
          endTime: selectedEvent.endTime,
        };
      }

      let response;
      if (isEditing) {
        response = await Axios.put(
          `${Constant.apiBasePath}HomepageBanner/edit/${editBannerId}`,
          bannerData,
          {
            headers: { token },
          }
        );
      } else {
        response = await Axios.post(
          `${Constant.apiBasePath}HomepageBanner`,
          bannerData,
          {
            headers: { token },
          }
        );
      }

      if (response.data.status === Constant.statusSuccess) {
        this.setState({
          message: isEditing
            ? "Banner updated successfully"
            : "Banner added successfully",
          messageColor: "green",
        });
        this.fetchBanners();
        this.handleModalClose();
      } else {
        this.setState({ message: response.data.message, messageColor: "red" });
      }
      this.props.history.push("/homepage-banner");
    } catch (err) {
      console.error(
        isEditing ? "Error updating banner:" : "Error adding banner:",
        err
      );
    }
  };

  handleEditBanner = (banner) => {
    this.setState(
      {
        showModal: true,
        isEditing: true,
        editBannerId: banner._id,
        type: banner.type,
        eventId: banner.eventId._id,
        rank: banner.rank,
      },
      () => {
        // Fetch the event options for the type and populate the modal
        this.fetchEventOptions(banner.type);
      }
    );
  };

  handleDeleteBanner = async (id) => {
    if (!window.confirm("Delete the Banner?")) return;
    try {
      const token = getAccessToken();
      const response = await Axios.delete(
        `${Constant.apiBasePath}HomepageBanner/delete/${id}`,
        {
          headers: { token },
        }
      );
      if (response.data.status === Constant.statusSuccess) {
        this.setState({
          message: "Banner deleted successfully",
          messageColor: "green",
        });
        this.fetchBanners();
      } else {
        this.setState({ message: response.data.message, messageColor: "red" });
      }
    } catch (err) {
      console.error("Error deleting banner:", err);
    }
  };

  render() {
    const {
      banners,
      showModal,
      type,
      eventId,
      message,
      messageColor,
      eventOptions,
      isEditing,
    } = this.state;

    return (
      <div className="content-page">
        <div className="content">
          <div className="header-common" style={{ gap: "10px" }}>
            <div className="center-items">
              <h4 className="page-title-heading">Homepage Banner Management</h4>
            </div>
            <div className="center-items text-right">
              <Button
                variant="info"
                className=" "
                onClick={this.handleShowModal}
              >
                Add New Banner
              </Button>
            </div>
          </div>
          <p style={{ color: messageColor }}>{message}</p>
          <div className="table-wrapper tab-content">
            <div className="tab-pane show active" id="buttons-table-preview">
              <table className=" table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Image</th>
                    <th>Type</th>
                    <th>Event ID</th>
                    <th>Rank</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {banners.map((banner, index) => (
                    <tr key={index}>
                      <td className="namecol">{banner.name}</td>
                      <td>
                        <img
                          src={
                            banner.type !== "contest" &&
                            typeof banner.eventId === "object" &&
                            banner.eventId !== null
                              ? banner.eventId.thumbnail
                              : banner.image
                          }
                          alt="Banner"
                          style={{ width: 50, height: 50 }}
                        />
                      </td>
                      <td>{banner.type}</td>
                      <td className="namecol">
                        {banner.eventId
                          ? banner.eventId.name || banner.eventId._id
                          : "N/A"}
                      </td>
                      <td>{banner.rank}</td>
                      <td className="action-div">
                        <Button
                          variant="warning"
                          onClick={() => this.handleEditBanner(banner)}
                        >
                          Edit
                        </Button>
                        <Button
                          variant="danger"
                          onClick={() => this.handleDeleteBanner(banner._id)}
                        >
                          Delete
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <Modal
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            show={showModal}
            onHide={this.handleModalClose}
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {isEditing ? "Edit Banner" : "Add New Banner"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group controlId="formType">
                  <Form.Label>Type</Form.Label>
                  <Form.Control
                    as="select"
                    name="type"
                    value={type}
                    onChange={this.handleChange}
                  >
                    <option value="contest">Contest</option>
                    <option value="open-mic">open-mic</option>
                    <option value="openMic">openMic</option>
                    <option value="registration">Registration</option>
                    <option value="meetings">Meeting</option>
                    <option value="simple-banner">Simple-banner</option>
                  </Form.Control>
                </Form.Group>
                <Form.Group controlId="formEventId">
                  <Form.Label>Event ID</Form.Label>
                  <Form.Control
                    as="select"
                    name="eventId"
                    value={eventId}
                    onChange={this.handleChange}
                  >
                    <option value="">Select an event</option>
                    {eventOptions.map((event) => (
                      <option key={event._id} value={event._id}>
                        {event.name}
                      </option>
                    ))}
                  </Form.Control>
                  {eventId && (
                    <div className="mt-2">
                      <small className="text-info d-block">
                        Selected event preview:
                      </small>
                      {(() => {
                        const selectedEvent = eventOptions.find(
                          (event) => event._id === eventId
                        );
                        return selectedEvent ? (
                          <div>
                            <div className="mb-2">
                              <small className="text-muted d-block">
                                Main Image:
                              </small>
                              <img
                                src={
                                  selectedEvent.image || this.defaultImageUrl
                                }
                                alt="Event preview"
                                style={{
                                  maxWidth: "200px",
                                  maxHeight: "150px",
                                  marginTop: "5px",
                                  border: "1px solid #ddd",
                                  borderRadius: "4px",
                                }}
                              />
                            </div>
                            {selectedEvent.mobileImage && (
                              <div className="mb-2">
                                <small className="text-muted d-block">
                                  Mobile Image:
                                </small>
                                <img
                                  src={selectedEvent.mobileImage}
                                  alt="Mobile preview"
                                  style={{
                                    maxWidth: "200px",
                                    maxHeight: "150px",
                                    marginTop: "5px",
                                    border: "1px solid #ddd",
                                    borderRadius: "4px",
                                  }}
                                />
                              </div>
                            )}
                            <small className="text-muted d-block mt-1">
                              {selectedEvent.name}
                            </small>
                          </div>
                        ) : null;
                      })()}
                    </div>
                  )}
                </Form.Group>
                <Form.Group controlId="formRank">
                  <Form.Label>Rank</Form.Label>
                  <Form.Control
                    type="number"
                    name="rank"
                    value={this.state.rank}
                    onChange={this.handleChange}
                    placeholder="Enter rank"
                  />
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={this.handleModalClose}>
                Close
              </Button>
              <Button variant="primary" onClick={this.handleAddBanner}>
                {isEditing ? "Update Banner" : "Add Banner"}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

export default HomepageBannerManagement;
